module.exports = __webpack_public_path__ + "media/images/starstream-8d718957.png";